<template>
  <div>
    <section class="logo-wrapper">
      <img src="@/assets/TME LOGO.png" class="logo__img">
      <span class="logo__title">{{ $t('header.title') }}</span>
    </section>

    <p class="register-title">{{ $t('account.registerAccount') }}</p>

    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-width="80px"
      size="medium"
    >
      <el-form-item
        :label="$t('account.username')"
        prop="nickname"
      >
        <el-input
          v-model="form.nickname"
          :placeholder="$t('account.nicknamePlaceholder')"
        ></el-input>
      </el-form-item>
      <el-form-item
        :label="$t('account.email')"
        prop="email"
      >
        <el-input
          v-model="form.email"
          :placeholder="$t('account.emailPlaceholder')"
        ></el-input>
      </el-form-item>
      <el-form-item
        :label="$t('account.password')"
        prop="pwd"
      >
        <password-input v-model="form.pwd"></password-input>
      </el-form-item>
      <el-form-item
        :label="$t('account.confirmPassword')"
        prop="pwdAgain"
      >
        <el-input
          type="password"
          v-model="form.pwdAgain"
          :placeholder="$t('account.passwordAgainPlaceholder')"
        ></el-input>
      </el-form-item>
      <el-tooltip
        effect="dark"
        content="请阅读同意服务条款及隐私协议"
        placement="top"
        :manual="true"
        v-model="showAgreementTip"
      >
        <div class="center agreement-wrapper">
          <el-checkbox v-model="agreement" :label="true" @change="showAgreementTip = false">
            已阅读并同意
          </el-checkbox>
          <el-button type="text" @click="handleShowUserAgreement">用户协议</el-button>
          和
          <el-button type="text" @click="handleShowPrivacy">隐私政策</el-button>
        </div>
      </el-tooltip>
      <section class="center register-btn">
        <el-button
          type="primary"
          size="medium"
          :loading="loading"
          @click="handleRegister"
        >
          {{ $t('account.register') }}
        </el-button>
        <el-button type="text" @click="handleLogin">使用已有账户登录</el-button>
      </section>
      <p class="err-msg" v-if="errMsg">
        {{ errMsg }}
      </p>
    </el-form>

    <!-- 用户协议和隐私政策的展示弹窗 -->
    <el-dialog
      title=""
      :visible.sync="showDialog"
      width="40%"
      top="10vh"
      :show-close="false"
      :center="true"
      :close-on-click-modal="false"
      destroy-on-close
      @close="handleClose"
    >
      <section style="padding: 0 10px;height: 600px;overflow-y: auto;">
        <cherry-markdown
          v-if="markdownMap[showType]"
          class="markdown"
          markdown-id="register-markdown"
          :content="markdownMap[showType]"
          readonly
        ></cherry-markdown>
      </section>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleClose">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { validatorPwd, createValidatorPwdAgain, validatorEmail, getErrorCode, getDefaultErrorText } from './mixin'
import authService from '@/api/auth'
import { ls } from '@/utils/index'
import PasswordInput from './components/PasswordInput'
import CherryMarkdown from '@/components/CherryMarkdown'

export default {
  name: 'Register',
  components: {
    PasswordInput,
    CherryMarkdown
  },
  data() {
    const validatorPwdAgain = createValidatorPwdAgain(this, 'form.pwd')

    return {
      loading: false,
      errMsg: '',
      form: {
        nickname: '',
        email: '',
        pwd: '',
        pwdAgain: ''
      },
      agreement: false,
      showAgreementTip: false,
      showType: 'agreement',
      showDialog: false,

      rules: {
        nickname: [
          { required: true, message: this.$t('account.nicknamePlaceholder'), trigger: 'blur' },
          { max: 10, message: this.$t('account.nicknameValidPlaceholder'), trigger: 'blur' },
        ],

        email: [
          { required: true, message: this.$t('account.emailPlaceholder'), trigger: 'blur' },
          { validator: validatorEmail, trigger: 'blur' }
        ],

        pwd: [
          { required: true, message: this.$t('account.passwordPlaceholder'), trigger: 'blur' },
          { validator: validatorPwd, trigger: 'blur' }
        ],

        pwdAgain: [
          { required: true, validator: validatorPwdAgain, trigger: 'blur' }
        ]
      }
    }
  },

  computed: {
    ...mapGetters(['hasLogin', 'markdownMap', 'markdownVersionMap']),
    isShowAgreement() {
      return this.showType === 'agreement'
    },
  },

  methods: {
    handleShowUserAgreement() {
      this.showType = 'agreement'
      this.showDialog = true
    },
    handleShowPrivacy() {
      this.showType = 'privacy'
      this.showDialog = true
    },
    handleClose() {
      this.showDialog = false
    },

    handleLogin() {
      if (!this.hasLogin) {
        this.$store.commit('login', true)
      } else {
        this.$message.warning('已登陆')
      }
    },

    async handleRegister() {
      try {
        await this.$refs.form.validate()
      } catch (e) {
        return
      }

      // 同意服务条款
      if (!this.agreement) {
        this.showAgreementTip = true
        return
      }

      this.errMsg = ''
      this.loading = true

      const data = {
        name: this.form.nickname,
        email: this.form.email,
        password: this.form.pwd,
        lang: ls.getItem('lang', 'zh'),
        version: this.markdownVersionMap.agreement
      }

      // console.log('register data => ', data)
      try {
        const { code } = await authService.register(data)
        if (code === 200) {
          this.$message.success(this.$t('account.registerSuccessMessage'))
          this.$refs.form.resetFields()
        } else {
          this.errMsg = getErrorCode()[code]
        }
      } catch (e) {
        this.errMsg = getDefaultErrorText()
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>

::v-deep {
  .el-dialog__header {
    display: none;
  }

  .dialog-footer {
    text-align: center;
  }
}
.center {
  text-align: center;
  margin-left: 80px;
}
.logo-wrapper {
  display: flex;
  align-items: center;
  margin-left: 100px;
  .logo__img {
    width: 90px;
    height: 50px;
  }

  .logo__title {
    font-size: 24px;
    font-weight: bold;
  }
}
.register-title {
  margin: 0 0 10px 80px;
  font-size: 14px;
  text-align: center;
}

.agreement-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;

  ::v-deep {
    .el-checkbox__label, .el-button {
      font-size: 14px;
    }

    .el-button {
      margin: 0 10px;
    }

    .el-popper[x-placement^="top"] .popper__arrow::after {
      border-top-color: #303133;
    }
  }
}

.register-btn {
  margin-top: 15px;
  display: flex;
  align-items: center;
  flex-direction: column;

  ::v-deep .el-button {
    display: block;
    &.el-button--primary {
      width: 180px;
    }
  }
}
</style>
